module.exports = "/_next/static/images/8bf85e47f043118f82c621baad635929-hero-variant-b-desktop.jpg";